import qs from "qs";
import { getCookie, StorageMobile } from "screens/register/util";
import { AuthType } from "types/oauth";
import { AccessTokenQueryKey } from "utils/oauth";

let _restaurantData_: any = null;
let _onboardingForTwilio_: boolean = false;
export const getLinkParams = () => {
  const [, param] = window.location.href.split("?");
  return param ? qs.parse(param) : {};
};

export const getAccessTokenObj = () => {
  const accesstokenStr = localStorage.getItem(AccessTokenQueryKey);
  if (!accesstokenStr) {
    return {};
  }
  return JSON.parse(accesstokenStr) as AuthType;
};

export const languageKey = "lang";
const defaultLang = "zh";
const checkLang = (lang: string) => {
  return lang.toLocaleLowerCase().includes("en") ? "en" : defaultLang;
};

export const getLanguage = () => {
  // 嵌入在smart_ordering里，读的是cookie
  if ((_restaurantData_ && !_restaurantData_.isEnableLanguageSwitch) || _onboardingForTwilio_) {
    return 'en';
  }
  const { source } = getLinkParams();
  if (source === "smart_ordering") {
    const cookieLang = getCookie("lang");
    if (cookieLang === "en" || cookieLang === "zh") {
      return cookieLang;
    }
  }
  const lang = window.localStorage.getItem(languageKey);
  if (lang) return lang;
  // 读取浏览器的language
  const language = window.navigator.language;
  if (language) {
    return checkLang(language);
  }

  const languages = window.navigator.languages;
  if (Array.isArray(languages) && languages.length > 0) {
    return checkLang(languages[0]);
  } else {
    return defaultLang;
  }
};

export const logout = () => {
  window.localStorage.removeItem(AccessTokenQueryKey);
  StorageMobile("remove");
};

export const getNavPath = (suffixStr: string) => {
  const paramStr = qs.stringify(getLinkParams());
  return `/${suffixStr}?${paramStr}`;
};

export function registerAuthCodeInfo(restaurantData: any, onboardingForTwilio: boolean) {
  _restaurantData_ = restaurantData
  _onboardingForTwilio_ = onboardingForTwilio;
}